import "./SponsorStrip.css";

// Card #1639 (design §7.1) — renders inside ScoreboardFrame's `sponsorSlot`
// on the sponsor-capable mode types only (1, 2, 6, 7 — see modeTypes.js's
// sponsorVariantForModeType, the FE-owned gate: the public composed endpoint
// resolves `sponsor` regardless of modeType, apps/score-api/src/handlers/
// scoreboard-public.js's resolveSponsorEnvelope).
//
// `sponsor` is `{ textLine, squareUrl, wideUrl } | null` straight off that
// envelope. `variant` is "square" (info-block families, types 1/2) or "wide"
// (ranked-list families, types 6/7). The missing-data rule applies to the
// whole component (design §7.1: "No sponsor declared -> the strip is
// omitted"): no sponsor, or no image for the variant this board needs, and
// this renders nothing at all — never an empty box or a broken <img>.
export default function SponsorStrip({ sponsor, variant }) {
  if (!sponsor) return null;
  const imageUrl = variant === "wide" ? sponsor.wideUrl : sponsor.squareUrl;
  if (!imageUrl) return null;

  return (
    <div className={`sponsor-strip sponsor-strip--${variant}`} data-testid="sponsor-strip">
      <img
        src={imageUrl}
        alt=""
        className="sponsor-strip__image"
        data-testid="sponsor-strip-image"
      />
      {sponsor.textLine ? (
        <p className="sponsor-strip__text" data-testid="sponsor-strip-text">
          {sponsor.textLine}
        </p>
      ) : null}
    </div>
  );
}
